// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"styles-module--socialLink--2_t_a","socialIcon":"styles-module--socialIcon--3cxes"};